import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=bc895016"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./collection.vue?vue&type=custom&index=0&blockType=stile&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports